module.exports = __webpack_public_path__ + "static/media/14UNEP22.3e8731e7.jpg";